export default __webpack_public_path__ + "static/media/early-payments-usecase2.9fadba3c.png";